import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user.model';
import { NotificationService } from '../../services/notification.service';
import { NotificationComponent } from '../../components/notification/notification.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  standalone: true,
  imports: [CommonModule, NotificationComponent]
})
export class UsersComponent implements OnInit {
  users: User[] = [];
  roles: string[] = ['superadmin', 'admin', 'editor', 'subscriber'];
  currentRole: string = 'superadmin';
  
  constructor(
    private userService: UserService,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.loadUsers();
  }

  loadUsers(): void {
    this.userService.getUsers().subscribe({
      next: (users) => {
        this.users = users;
      },
      error: (error) => console.error('Error loading users:', error)
    });
  }

  getUsersByRole(role: string): User[] {
    return this.users.filter(user => user.roles[role as keyof typeof user.roles]);
  }

  getUsersWithoutRoles(): User[] {
    return this.users.filter(user => 
      !Object.values(user.roles || {}).some(hasRole => hasRole)
    );
  }

  getUserRoles(user: User): string[] {
    return Object.entries(user.roles || {})
      .filter(([_, value]) => value)
      .map(([key, _]) => key);
  }

  async updateUserRole(userId: string, role: string): Promise<void> {
    try {
      await this.userService.updateUserRole(userId, role);
      this.loadUsers();
      this.notificationService.show({
        message: `Role ${role} added successfully`,
        type: 'success'
      });
    } catch (error) {
      console.error('Error updating user role:', error);
      this.notificationService.show({
        message: 'Failed to update user role',
        type: 'error'
      });
    }
  }

  async removeUserRole(userId: string, role: string): Promise<void> {
    try {
      await this.userService.removeUserRole(userId, role);
      this.loadUsers();
      this.notificationService.show({
        message: `Role ${role} removed successfully`,
        type: 'success'
      });
    } catch (error) {
      console.error('Error removing user role:', error);
      this.notificationService.show({
        message: 'Failed to remove user role',
        type: 'error'
      });
    }
  }
} 